import script from "./privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy.vue?vue&type=script&setup=true&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=501ac81e&lang=scss"

const __exports__ = script;

export default __exports__